import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { media } from '@/shared/components';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ScenarioCantProcessModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const ScenarioCantProcessModal: FC<ScenarioCantProcessModalProps> = ({ beneficiaries }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'scenarioCantProcess' });

  const modals = useModalsStore();

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <InnerForm>
        <TextPadding>{t('notRegisteredText')}</TextPadding>
        <span>{t('notifyText')}</span>
        <List>
          {beneficiaries.map((fullname, index) => (
            <li key={index}>{t('beneficiary', { index: index + 1, fullname })}</li>
          ))}
        </List>
      </InnerForm>
      <Buttons>
        <ButtonIw onClick={modals.closeModal}>{t('ok')}</ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 24px 0;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  ${media.iwMobile} {
    flex-direction: column-reverse;
  }
`;

const List = styled.ul`
  padding-top: 8px;
  list-style-position: inside;
`;

const TextPadding = styled.span`
  padding-bottom: 24px;
`;
